import { postRequest, patchRequest, deleteRequest, getRequest } from "@react/helpers/fetch"

export const createSubcontract = (projectId, body) =>
  postRequest({ url: `/projects/${projectId}/subcontracts.json`, body: { subcontract: body } })

export const updateSubcontract = (projectId, id, body) =>
  patchRequest({ url: `/projects/${projectId}/subcontracts/${id}.json`, body: { subcontract: body } })

export const signSubcontract = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/subcontracts/${id}/sign.json`, body: {} })

export const startSubcontract = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/subcontracts/${id}/start.json`, body: {} })

export const completeSubcontract = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/subcontracts/${id}/complete.json`, body: {} })

export const cancelSubcontract = (projectId, id) =>
  patchRequest({ url: `/projects/${projectId}/subcontracts/${id}/cancel.json`, body: {} })

export const destroySubcontract = (projectId, id) =>
  deleteRequest(`/projects/${projectId}/subcontracts/${id}.json`)

export const fetchSuppliers = (suppliersUrl) => getRequest(suppliersUrl)

export const linkPurchaseInvoice = (projectId, id, purchaseInvoiceId) =>
  postRequest({
    url:  `/projects/${projectId}/subcontracts/${id}/link_purchase_invoice.json`,
    body: { purchase_invoice_id: purchaseInvoiceId },
  })

export const unlinkPurchaseInvoice = (projectId, id, purchaseInvoiceId) =>
  postRequest({
    url:  `/projects/${projectId}/subcontracts/${id}/unlink_purchase_invoice.json`,
    body: { purchase_invoice_id: purchaseInvoiceId },
  })

export const candidatePurchaseInvoices = (projectId, id) =>
  getRequest(`/projects/${projectId}/subcontracts/${id}/candidate_purchase_invoices.json`)
